import mutations from "./mutations";

(function (window) {
  const ERROR = "error";
  const LOAD = "load";
  const SELECTOR = "img";
  const { document } = window;

  function init() {
    mutations.add(SELECTOR, process);
    document.querySelectorAll(SELECTOR).forEach((image) => process(image));
  }

  function onerror({ target: image }) {
    image.title = image.alt;
    image.dataset.status = "error";

    const picture = image.closest("picture");

    if (picture) {
      picture.querySelectorAll("source").forEach((source) => {
        picture.removeChild(source);
      });
    }

    if (image.srcset) {
      image.removeAttribute("srcset");
    }

    image.dispatchEvent(new window.Event(LOAD));
  }

  function onload({ target: image }) {
    if (image.dataset.status === "loading") {
      delete image.dataset.status;
    }
  }

  function process(image) {
    image.dataset.status = "loading";
    image.addEventListener(ERROR, onerror, { once: true });
    image.addEventListener(LOAD, onload, { once: true });
  }

  document.addEventListener("DOMContentLoaded", init, { once: true });
})(globalThis);
